import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from '../services/axios';
import toast from 'react-hot-toast';

const VerifyEmail = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const token = searchParams.get('token');

    useEffect(() => {
        const verifyEmail = async () => {
            if (!token) {
                toast.error('Verification token is missing');
                setLoading(false);
                return;
            }

            try {
                await axios.get(`/auth/verify-email?token=${token}`);
                setSuccess(true);
                toast.success('Email verified successfully! You can now log in.');
                setTimeout(() => navigate('/login'), 2000);
            } catch (error) {
                toast.error(error.response?.data?.message || 'Email verification failed');
                setLoading(false);
            }
        };

        verifyEmail();
    }, [token, navigate]);

    return (
        <div className="min-h-screen bg-white flex items-center justify-center px-4">
            <div className="max-w-md w-full space-y-8 text-center">
                <div>
                    <h2 className="text-3xl font-bold text-gray-900">
                        {loading ? 'Verifying Email...' : success ? 'Email Verified!' : 'Verification Failed'}
                    </h2>
                    <p className="mt-2 text-sm text-gray-600">
                        {loading && 'Please wait while we verify your email address'}
                        {success && 'Your email has been verified successfully. Redirecting to login...'}
                        {!loading && !success && 'There was an issue verifying your email. Please try again.'}
                    </p>
                </div>

                {!loading && !success && (
                    <Link
                        to="/login"
                        className="inline-block mt-4 btn-primary"
                    >
                        Back to Login
                    </Link>
                )}

                {loading && (
                    <div className="mt-6">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black mx-auto"></div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;
